import React, { useState } from 'react'
import { Checkbox, Modal, Spin } from 'antd'
import Flex from 'components/Flex'
import useDownloadGuard from 'hooks/useDownloadGuard'
import Button from '../../../../components/Button/index'
import {
  TextDescription,
  UploadMsgFlex,
} from '../../../../components/UIComponents/CloseRolePopup/style'
import ApprovedModelIcon from '../../../../components/icons/TPORequestsIcons/PopupIcon/ApprovedModelIcon'
import SuccessIcon from '../../../../components/icons/SubmitCloseIcon'
import { CheckBoxItem, ModalContainer } from '../StudentReports/Styles'
import {
  getSortingValues,
  reportNameMap,
  excludeCategoryReports,
} from './reportData'
import { toCamelCase } from '../../../../utils/helpers'
const ExportPopup = ({
  open,
  setShowDrawer,
  apiState,
  ErrorMessage,
  exportCSV,
  state,
  instituteCampusId,
  setExported,
  exported,
  selectedReport,
  setDownloadType,
  selectedButton,
  downloadType,
  specializationIdArr,
  departmentIdArr,
  customState,
  setCustomState,
}) => {
  const [selectedFormats, setSelectedFormats] = useState([])
  const [isLoadingState, setIsLoadingState] = useState(false)

  const handleClose = () => {
    setShowDrawer(false)
    setExported(false)
    setSelectedFormats([])
  }

  //Corporate Report TOP & LEAST Companies

  const CaptilizeLetter = text => {
    if (!text || typeof text !== 'string') {
      return 'Report'
    }
    const words = text.toLowerCase().split('_')
    const camelCase = words
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
    return camelCase
  }

  const reportName = reportNameMap[selectedReport] || selectedReport

  const handleExport = async type => {
    setIsLoadingState(true)
    setDownloadType(type)
    
    // PG-only reports should not be constrained by job category
    const isPgOnlyReport = [
      'Prior education background report(Only for PG)',
      'Prior work experience report(Only for PG)'
    ].includes(selectedReport)
    
    let payload = {
      domainId: apiState.domainId,
      degreeId: apiState.degreeId,
      // streamId: apiState.departmentId,
      streamId: departmentIdArr,
      specializationId: specializationIdArr,
      ...(isPgOnlyReport ? {} : { jobCategory: state.selectedCategory }),
      ...(apiState?.degreeType ? { educationLevel: apiState.degreeType.split(',')[0] } : {}),
      yearOfPassing: state?.selectedPassingYear?.year,
      downloadType: type,
    }
    
    // For PG-only reports, don't send courses array - use individual IDs like Batch Folders
    if (
      !isPgOnlyReport &&
      state?.selectedCourses
    ) {
      const selectedCourses = state?.selectedCourses?.flatMap(item => {
        if (item?.degree?.length > 0) {
          return item.degree.flatMap(degreeItem => {
            if (degreeItem?.department?.length > 0) {
              return degreeItem.department.flatMap(departItem => {
                if (departItem?.specialization?.length > 0) {
                  return departItem.specialization.map(specItem => ({
                    domainId: item.domainValue,
                    degreeId: degreeItem?.degreeValue,
                    streamId: departItem?.departmentValue,
                    specialisationId: specItem?.specializationValue,
                  }))
                } else {
                  return {
                    domainId: item.domainValue,
                    degreeId: degreeItem?.degreeValue,
                    streamId: departItem?.departmentValue,
                  }
                }
              })
            } else {
              return {
                domainId: item.domainValue,
                degreeId: degreeItem?.degreeValue,
              }
            }
          })
        } else {
          return {
            domainId: item.domainValue,
          }
        }
      })

      payload.courses = selectedCourses
    }

    if (selectedReport === 'Custom report') {
      payload.downloadList = state?.downloadList || []
    }
    // Apply sorting configuration
    const sortingValues = getSortingValues(selectedReport, selectedButton)
    payload = { ...payload, ...sortingValues }

    if (type === 'xlsx') {
      try {
        const blob = await exportCSV(
          instituteCampusId,
          payload,
          type,
          selectedReport,
          false
        )
        const url = window.URL.createObjectURL(new Blob([blob]))
        const link = document.createElement('a')
        link.href = url

        const fileName = excludeCategoryReports.includes(selectedReport)
          ? `${CaptilizeLetter(reportName)}.xlsx`
          : `${CaptilizeLetter(state?.selectedCategory || 'Report')}_${CaptilizeLetter(
              reportName
            )}.xlsx`

        link.setAttribute('download', fileName)

        document.body.appendChild(link)
        link.click()
        link.parentNode.removeChild(link)
        setExported(true)
        setCustomState(false)
      } catch (error) {
        ErrorMessage(error?.response?.data?.message || error?.message || 'Failed to export file')
      } finally {
        setIsLoadingState(false)
      }
    } else if (type === 'googlesheet') {
      try {
        const data = await exportCSV(
          instituteCampusId,
          payload,
          type,
          selectedReport,
          false
        )
        window.open(data.data.url, '_blank')

        setExported(true)
        setCustomState(false)
      } catch (error) {
        ErrorMessage(error?.response?.data?.message || error?.message || 'Failed to export file')
      } finally {
        setIsLoadingState(false)
      }
    } else {
      try {
        const blob = await exportCSV(
          instituteCampusId,
          payload,
          type,
          selectedReport,
          false
        )
        const url = window.URL.createObjectURL(
          new Blob([blob], { type: 'text/csv' })
        )
        const link = document.createElement('a')
        link.href = url

        const fileName = excludeCategoryReports.includes(selectedReport)
          ? `${CaptilizeLetter(reportName)}.csv`
          : `${CaptilizeLetter(state?.selectedCategory || 'Report')}_${CaptilizeLetter(
              reportName
            )}.csv`
        link.setAttribute('download', fileName)

        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        setExported(true)
        setCustomState(false)
      } catch (error) {
        ErrorMessage(error?.response?.data?.message || error?.message || 'Failed to export file')
      } finally {
        setIsLoadingState(false)
      }
    }
  }
  const exportGuard = useDownloadGuard(() => handleExport(selectedFormats), {
    disabled: selectedFormats?.length === 0,
  })

  const menuItem = [
    {
      label: 'Excel',
      type: 'xlsx',
    },
    {
      label: 'CSV',
      type: 'csv',
    },
    {
      label: 'Google Sheet',
      type: 'googlesheet',
    },
  ]

  const handleCheckboxChange = value => {
    setSelectedFormats(value)
  }

  return (
    <Modal
      open={open}
      centered
      footer={''}
      maskClosable={false}
      closable={false}
      bodyStyle={{
        borderRadius: '20px',
        padding: '20px',
        textAlign: 'center',
        height: '434px',
        width: '650px',
      }}
    >
      <Spin
        size="small"
        spinning={isLoadingState}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {customState || !exported ? (
          <UploadMsgFlex
            column
            center
            centerVertically
            style={{ marginTop: '20px' }}
          >
            <div>{<ApprovedModelIcon />}</div>
            <TextDescription>
              Which format do you want to export this data?
            </TextDescription>
            {/* {((selectedReport == 'Custom report' && exported) || !exported) && ( */}
            <ModalContainer>
              {menuItem?.map(item => (
                <CheckBoxItem>
                  <Checkbox
                    key={item?.type}
                    checked={selectedFormats?.includes(item?.type)}
                    onChange={() => handleCheckboxChange(item?.type)}
                  >
                    {item?.label}
                  </Checkbox>
                </CheckBoxItem>
              ))}
            </ModalContainer>
            {/* )} */}
            <Flex style={{ gap: '1em !important' }}>
              <>
                <Button.Secondary text={'Back'} onClick={handleClose} />
                <Button.Primary
                  text={'Export'}
                  loading={exportGuard.loading}
                  disabled={exportGuard.disabled}
                  onClick={exportGuard.onClick}
                />
              </>
            </Flex>
          </UploadMsgFlex>
        ) : (
          <UploadMsgFlex
            column
            center
            centerVertically
            style={{ marginTop: '6rem' }}
          >
            <div>{<SuccessIcon />}</div>
            <TextDescription>
              File exported to{' '}
              {toCamelCase(downloadType == 'xlsx' ? 'Excel' : downloadType)}.
            </TextDescription>

            <Flex style={{ gap: '1em !important' }}>
              <Button.Secondary text={'Close'} onClick={handleClose} />
            </Flex>
          </UploadMsgFlex>
        )}
      </Spin>
    </Modal>
  )
}

export default ExportPopup
